import React from "react";

import Background from "../../../assets/dinner/dinner-bg-01.png";

import GamePageLayout from "../GamePageLayout";

const DinnerPage1 = ({ setCurrentPage }) => {
  return (
    <GamePageLayout
      bg={Background}
      onClickNext={() => setCurrentPage("dinner-2")}
    >
      와 오늘 하루 불태웠다.
      <br />
      오늘 저녁은 맥주를 마시며
      <br />
      떡볶이를 먹어야겠어.
    </GamePageLayout>
  );
};

export default DinnerPage1;
